
const TextWithLineBreaks = ({
  dynamicValues,
  textKey,
  elementClassName,
  t,
  lineBreakClassname = '',
  element = 'p',
}) => {
  const Element = element
  return (
    <Element className={elementClassName}>
      {dynamicValues
        ? t.rich(textKey, {
            br: () => <br className={lineBreakClassname} />,
            ...dynamicValues,
          })
        : t.rich(textKey, {
            br: () => <br className={lineBreakClassname} />,
          })}
    </Element>
  )
}

export default TextWithLineBreaks
